export class Response {
  status: number;
  code: number;
  message: string;
  data: any;
}
